import { InterceptedCoroutine142wh200e9wbr as InterceptedCoroutine } from '../InterceptedCoroutine.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../Standard.mjs';
import {
  GeneratorCoroutineImpl2pzxhv55we2g3 as GeneratorCoroutineImpl,
  get_dummyGeneratoryu26m7xm6osk as get_dummyGenerator,
  access$_get_jsIterators__geagmj3234lk8d9q7ro as access$_get_jsIterators__geagmj,
  access$_get_unknown__2v7dtz2ojw8x67rbar8 as access$_get_unknown__2v7dtz,
  access$_get_savedResult__bwlkfn2h5qcmd9ffu3u as access$_get_savedResult__bwlkfn,
  isGeneratorSuspendStepcb59h14on5am as isGeneratorSuspendStep,
} from '../GeneratorCoroutineImpl.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from './Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../Unit.mjs';
import {
  _Result___get_value__impl__bjfvqg2ei4op8d4d2m as _Result___get_value__impl__bjfvqg,
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function intercepted(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine() ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bd();
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
  throw NotImplementedError().qd('It is intrinsic method');
}
function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
  throw NotImplementedError().qd('It is intrinsic method');
}
function createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = get_dummyGenerator();
  var tmp_0 = get_COROUTINE_SUSPENDED();
  // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.addNewIterator' call
  var iterator = tmp(tmp_0, () => {
    var it = continuation;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(receiver, it) : _this__u8e3s4.s2(receiver, it);
  });
  // Inline function 'kotlin.js.asDynamic' call
  access$_get_jsIterators__geagmj(continuation).push(iterator);
  return continuation;
}
function startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  continuation.wc_1 = true;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var result = typeof a === 'function' ? a(receiver, continuation) : _this__u8e3s4.s2(receiver, continuation);
  continuation.wc_1 = false;
  // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.shouldResumeImmediately' call
  if (!(_Result___get_value__impl__bjfvqg(access$_get_unknown__2v7dtz(continuation)) === _Result___get_value__impl__bjfvqg(access$_get_savedResult__bwlkfn(continuation)))) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
    continuation.rc(tmp$ret$5);
  }
  return result;
}
function startCoroutineUninterceptedOrReturnGeneratorVersion_0(_this__u8e3s4, receiver, param, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  continuation.wc_1 = true;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var result = typeof a === 'function' ? a(receiver, param, continuation) : _this__u8e3s4.rd(receiver, param, continuation);
  continuation.wc_1 = false;
  // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.shouldResumeImmediately' call
  if (!(_Result___get_value__impl__bjfvqg(access$_get_unknown__2v7dtz(continuation)) === _Result___get_value__impl__bjfvqg(access$_get_savedResult__bwlkfn(continuation)))) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
    continuation.rc(tmp$ret$5);
  }
  return result;
}
function suspendOrReturn(generator, continuation) {
  var tmp;
  // Inline function 'kotlin.js.asDynamic' call
  if (continuation.constructor === GeneratorCoroutineImpl()) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = continuation;
  } else {
    tmp = new (GeneratorCoroutineImpl())(continuation);
  }
  var generatorCoroutineImpl = tmp;
  var value = generator(generatorCoroutineImpl);
  if (!isGeneratorSuspendStep(value))
    return value;
  // Inline function 'kotlin.js.unsafeCast' call
  var iterator = value;
  // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.addNewIterator' call
  // Inline function 'kotlin.js.asDynamic' call
  access$_get_jsIterators__geagmj(generatorCoroutineImpl).push(iterator);
  try {
    var iteratorStep = iterator.next();
    if (iteratorStep.done) {
      // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.dropLastIterator' call
      // Inline function 'kotlin.js.asDynamic' call
      access$_get_jsIterators__geagmj(generatorCoroutineImpl).pop();
    }
    return iteratorStep.value;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.dropLastIterator' call
      // Inline function 'kotlin.js.asDynamic' call
      access$_get_jsIterators__geagmj(generatorCoroutineImpl).pop();
      throw e;
    } else {
      throw $p;
    }
  }
}
//region block: exports
export {
  createCoroutineUninterceptedGeneratorVersion as createCoroutineUninterceptedGeneratorVersion2gduom218i9ay,
  intercepted as intercepted2ogpsikxxj4u0,
  startCoroutineUninterceptedOrReturnGeneratorVersion as startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn,
  startCoroutineUninterceptedOrReturnGeneratorVersion_0 as startCoroutineUninterceptedOrReturnGeneratorVersion36jld8bkc4ba2,
  suspendOrReturn as suspendOrReturn49pspzlx5djv,
};
//endregion

//# sourceMappingURL=IntrinsicsJs.mjs.map
